import { Directive } from '@angular/core';

@Directive({
  selector: '[comp-dialog-content-inner]',
})
export class DialogContentInnerDirective {}
